"use strict";
/**
 * Shared limits for the emissions system.
 * Used by both frontend (validation, UI messaging) and backend (schema validation).
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BULK_IMPORT_MAX_ROWS = void 0;
/** Maximum number of activity rows in a single bulk import */
exports.BULK_IMPORT_MAX_ROWS = 200;
